export default "#include <common>\n\nvoid main(){\n  gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\n}\n";